import React from "react";
import * as PropTypes from "prop-types";
import { exportButtons } from "../../constants";
import * as Highcharts from "highcharts";
import VariwideModule from "highcharts/modules/variwide";
import HighchartsReact from "highcharts-react-official";
import styleConstants from "../../styleConstants";

const MosaicChart = props => {
  let options = {
    chart: {
      type: "variwide",
      backgroundColor: null,
      style: {
        fontFamily: "'Source Sans Pro', sans-serif;"
      },
      height: "80%"
    },
    title: {
      text: null
    },
    plotOptions: {
      variwide: {
        stacking: "normal"
      }
    },
    xAxis: [
      {
        type: "category",
        opposite: true
      },
      {
        type: "linear",
        offset: 10,
        min: 0,
        max: 100,
        tickInterval: 20,
        title: {
          text: props.xAxisTitle
        },
        labels: {
          format: "{value}%",
          style: {
            fontSize: "0.75rem",
            color: styleConstants.colors.gray4
          }
        },
        lineColor: styleConstants.colors.gray4,
        tickPosition: "inside",
        tickLength: 5,
        tickColor: styleConstants.colors.gray4
      }
    ],
    yAxis: {
      offset: 10,
      min: 0,
      max: 100,
      tickInterval: 20,
      title: {
        text: props.yAxisTitle
      },
      labels: {
        format: "{value}%",
        style: {
          fontSize: "0.75rem",
          color: styleConstants.colors.gray4
        }
      },
      reversedStacks: props.reversedStacks,
      lineWidth: 1,
      lineColor: styleConstants.colors.gray4,
      tickPosition: "inside",
      tickLength: 5,
      tickWidth: 1,
      tickColor: styleConstants.colors.gray4
    },
    series: props.series,
    tooltip: {
      backgroundColor: "white",
      useHTML: true,
      outside: true,
      formatter: props.tooltipFormatter,
      style: {
        fontSize: "0.875rem",
        color: styleConstants.colors.gray6
      },
      enabled: !!props.tooltipFormatter
    },
    legend: {
      width: props.legendWidth,
      itemStyle: {
        textOverflow: null
      }
    },
    exporting: {
      buttons: {
        contextButton: {
          menuItems: exportButtons
        }
      },
      enabled: false
    },
    credits: {
      enabled: false
    }
  };

  if (props.legendPosition === "right") {
    options = {
      ...options,
      legend: {
        ...options.legend,
        layout: "vertical",
        align: "right",
        verticalAlign: "middle"
      }
    };
  }

  return (
    <HighchartsReact
      ref={props.innerRef}
      highcharts={VariwideModule(Highcharts)}
      options={options}
    />
  );
};

MosaicChart.propTypes = {
  xAxisTitle: PropTypes.string,
  yAxisTitle: PropTypes.string,
  series: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      data: PropTypes.arrayOf(PropTypes.array).isRequired
    })
  ).isRequired,
  reversedStacks: PropTypes.bool,
  legendPosition: PropTypes.oneOf(["bottom", "right"]),
  legendWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  absolute: PropTypes.bool,
  tooltipFormatter: PropTypes.func
};

MosaicChart.defaultProps = {
  reversedStacks: false,
  legendPosition: "bottom",
  tooltipFormatter: function(tooltip) {
    return tooltip.defaultFormatter.call(this, tooltip);
  }
};

export default React.forwardRef((props, ref) => (
  <MosaicChart innerRef={ref} {...props} />
));
